import AOS from 'aos';

AOS.init({
    duration: 1000,
    once: true
});



// WEBPACK FOOTER //
// ./src/js/components/animations.js